module.exports = __webpack_public_path__ + "img/image_5.039cfd52.png";